import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_Pill = _resolveComponent("Pill")!

  return (_openBlock(), _createBlock(_component_Pill, _mergeProps({ class: "w-max" }, _ctx.$attrs), {
    icon: _withCtx(() => [
      _createVNode(_component_svg_icon, {
        type: "mdi",
        path: _ctx.categoryIcon
      }, null, 8, ["path"])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16))
}